import { IReduxState } from '../../types/redux';
import { getPropertyGuidesGroup } from '../../utils/ab_mainpage_property_guides';
import { dealTypeFromJsonQuery } from '../../utils/category';
import { shouldNewFiltersShow } from '../../utils/filters';
import { shouldPropertyGuidesShow } from '../../utils/propertyGuides';
import { getExperimentGroup } from '../../utils/helpers/experiment_helpers';
import { connect } from 'react-redux';
import { HomeComponent, IHomeComponentProps, IHomeProps } from '../../components/Home/Home';
import { ESpecialTabs } from '../../constants/specialTabs';
import { selectSpecialTabActive } from '../../hooks/selectors/specialTabs';

const mapStateToProps = (state: IReduxState, { section }: IHomeProps): IHomeComponentProps => {
  const { page, mainpage, config, type, filters } = state;

  const propertyGuidesExperimentGroup = getPropertyGuidesGroup(mainpage.experiments || []);

  const newSearchType = dealTypeFromJsonQuery(filters.jsonQuery);

  const isNewFiltersVisible = shouldNewFiltersShow({ section });

  const isPropertyGuidesVisible = shouldPropertyGuidesShow({
    filters: { isNewFiltersVisible, oldSearchType: type.searchType, newSearchType },
    section,
    subdomain: config.subdomain,
    experimentGroup: propertyGuidesExperimentGroup,
  });

  return {
    pageKind: page.kind,
    isMortgageTabActive: selectSpecialTabActive(state) === ESpecialTabs.Mortgage,
    isFetching: mainpage.isFetching,
    top3: mainpage.top3,
    popularJks: mainpage.popularJks,
    recommendationExperimentGroup: getExperimentGroup(mainpage.experiments, 'newbuilding_recommendations'),
    isPropertyGuidesVisible,
  };
};

export const Home = connect<IHomeComponentProps, {}, IHomeProps>(mapStateToProps)(HomeComponent);
